require('./bootstrap');
require('adx-ui-kit/src/plugins/protected-input/js/protected-input');

// jQuery ajax settings
require('./ajax');
require('./menu');
require('./buttons');
require('./other');
require('./filters');

// TODO: Delete it all later
require('./utilities');
